export default __webpack_public_path__ + "static/media/330_dummy2016-consulting01-de.43ed09be.png";